import { useParams } from 'react-router-dom';
import { useGetCompany } from '../../hooks/use-hydra/admin';
import { useGetAssessmentTestSession } from '../../hooks/use-hydra/admin';
import PageWithAsyncData from '../../components/PageWithAsyncData';
import CompanyPageWrapper from '../../components/Admin/CompanyPageWrapper';
import { COMPANY_PAGES } from '../../components/Admin/CompanySideNavigation';
import Navbar from '../../components/Navbar';
import { ROUTES } from '../../routing';
import TestResult from '../../components/Admin/AssessmenTest/TestResult';

const NavbarWithBreadcrumbs = ({
  companyName,
  companyId,
  userName,
}: {
  companyName: string;
  companyId: string;
  userName: string;
}) => (
  <Navbar
    breadCrumbs={[
      {
        label: 'Home',
        url: ROUTES.HOME.getPath(),
      },
      {
        label: 'Teams',
        url: ROUTES.ADMIN.COMPANIES.getPath(),
      },
      {
        label: companyName,
        url: ROUTES.ADMIN.COMPANY.getPath({ companyId }),
      },
      {
        label: 'Assessment Results',
        url: ROUTES.ADMIN.ASSESSMENT_TEST_RESULTS.getPath({ companyId }),
      },
      {
        label: userName,
        url: null,
      },
    ]}
  />
);

export default function AssessmentTestResult() {
  const { id: companyId, assessmentTestSessionId } =
    useParams<{ id: string; assessmentTestSessionId: string }>();
  const {
    data: companyData,
    isLoading: isLoadingCompany,
    error: errorCompany,
    refetch: refetchCompany,
  } = useGetCompany(parseInt(companyId));
  const {
    data: testSession,
    isLoading: isLoadingTestSession,
    error: errorTestSession,
    refetch: refetchTestSession,
  } = useGetAssessmentTestSession(
    parseInt(companyId),
    parseInt(assessmentTestSessionId ?? '0')
  );

  return (
    <PageWithAsyncData
      isLoading={isLoadingCompany || isLoadingTestSession}
      error={errorCompany || errorTestSession}
      retry={() => {
        refetchCompany();
        refetchTestSession();
      }}
      noScroll
    >
      <NavbarWithBreadcrumbs
        companyName={companyData?.name ?? ''}
        companyId={companyId ?? ''}
        userName={testSession?.user?.name ?? ''}
      />
      <CompanyPageWrapper
        currentPage={COMPANY_PAGES.ASSESSMENT_TEST_RESULTS}
        shouldAddEmptyDiv={true}
      >
        <TestResult
          assessmentTestSessionId={assessmentTestSessionId ?? ''}
          companyId={companyId ?? ''}
        />
      </CompanyPageWrapper>
    </PageWithAsyncData>
  );
}
